import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import struct from 'python-struct'
import uuidParse from 'uuid-parse'
import { useTTUSUserSelective } from '../../../utils/user'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceEdge = ({ data }) => {

    const [idFilter, setIdFilter] = useState([])
    const userLookup = useTTUSUserSelective(idFilter)

    const tab_col = [
        {
            field: "user_id",
            headerName: "ID",
            minWidth: 150,
            suppressSizeToFit: true,

        },
        {
            field: "alias",
            minWidth: 150,
            headerName: "Username",
            suppressSizeToFit: true,
        },
        {
            field: "user_email",
            headerName: "User",
            minWidth: 150,
            suppressSizeToFit: true,

        },
        {
            field: "ttw_branch",
            headerName: "TTW Branch",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "client_type",
            headerName: "Client Type",
            minWidth: 150,
            suppressSizeToFit: true,

        },
        {
            field: "latency",
            headerName: "Latency",
            minWidth: 150,
            suppressSizeToFit: true,

        },
        {
            field: "clientPublicIp",
            headerName: "Public IP",
            minWidth: 150,
            suppressSizeToFit: true,
            hide: true

        },
        {
            field: "clientRealIp",
            headerName: "Real IP",
            minWidth: 150,
            suppressSizeToFit: true,
            hide: false
        },
        {
            field: "clientForwardedPort",
            headerName: "Forwarded Port",
            minWidth: 150,
            suppressSizeToFit: true,
            hide: false
        },
        {
            field: "clientInternalIps",
            headerName: "Internal IPs",
            minWidth: 150,
            suppressSizeToFit: true,
            hide: true

        },
        {
            field: "session_id",
            headerName: "Session ID",
            minWidth: 150,
            suppressSizeToFit: true,

        },
        {
            field: "logon_date",
            headerName: "Logon Date",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        let temp_ids = []

        if (data && Object.keys(data).length > 0) {
            tab_data_temp = Object.keys(data).sort((a, b) => (data[a].latency > data[b].latency) ? -1 : 1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])
                let sessionId = row.session_id
                if ((typeof (sessionId) !== "string")) {
                    let b = struct.pack("<QQ", [sessionId.hi, sessionId.lo])
                    sessionId = uuidParse.unparse(b)
                }
                temp_ids.push(row.user_id)

                const alias = row.user_id && userLookup[row.user_id] ? userLookup[row.user_id].alias : '-'

                rowData.push({
                    'uniqueId': sessionId,
                    'session_id': sessionId,
                    'user_id': row.user_id,
                    'alias': alias,
                    'user_email': row.user_email,
                    'client_type': row.client_type,
                    'latency': row.latency,
                    'ttw_branch': row.client_branch,
                    'clientPublicIp': row.client_public_ip,
                    'clientInternalIps': row.client_internal_ips,
                    'clientRealIp': row.client_real_ip,
                    'clientForwardedPort': row.client_forwarded_port,
                    'logon_date': row.logon_date,
                    'detailView': {
                        'head': {
                        },
                        'data': [
                            {
                                'type': 'json',
                                'subheader': 'More Information',
                                'content': {
                                    'productGroupIds': row.product_group_ids,
                                    'clientInternalIps': row.client_internal_ips,
                                    'clientPublicIp': row.client_public_ip,
                                    'clientRealIp': row.client_real_ip,
                                    'imPriceConflationPeriod': row.im_price_conflation_period,
                                    'latency': row.latency,
                                    'orderConflationPeriod': row.order_conflation_period,
                                    'pingLatency': row.ping_latency,
                                    'priceConflationPeriod': row.price_conflation_period,
                                    'queueDepth': row.queue_depth,
                                },
                            },
                        ],
                    },
                })
                return rowData
            }, [])
        }

        settab_data(tab_data_temp)
        setIdFilter(temp_ids)

    }, [data, userLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Sessions </Text>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceEdgev3"
                defaultSubTab="More Information"
                selection="multiple"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceEdge